import React, { useEffect, useState } from "react";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import "./Businessfranchise.css";
import FranchiseForm from "./FranchiseForm";

export default function Businessfranchise() {
  pageTitle("Business Franchise");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // All Franchise Data
  const franchiseData = [
    // {
    //   title: "Riyansh Beginner Franchise",
    //   category: "Beginner Franchise",
    //   tagline: "Start Small, Earn Big!",
    //   description:
    //     "A low-investment, high-return opportunity for individuals who want to start a solar business without an office setup.",
    //   features: [
    //     "No infrastructure required – Work remotely with zero overhead costs.",
    //     "Flexible business model – Work on your own time and at your own pace.",
    //     "Earn from multiple sources – Commissions on solar product sales, installations, and AMC services.",
    //     "Business Support – Marketing materials, training, and account management support.",
    //   ],
    //   investment: "₹65000 + GST (Non-Refundable)",
    //   offer: "Refundable Offer: Achieve 60KW EPC projects in 18 months.",
    // },
    {
      title: "Riyansh Start Up Franchise",
      category: "Start Up Franchise",
      tagline: "Exclusive Market Control!",
      description:
        "Gain exclusive distribution rights in your area and manage a solar supply network.",
      features: [
        "Open Market Business – Work as the only distributor in your assigned region.",
        "Multiple revenue streams – Earn from direct sales, downline commissions, and franchise appointments.",
        "Higher margins – Get distributor-level pricing for bulk solar product sales.",
        "Business Setup Support – Sample products, marketing kits, and website setup included.",
      ],
      investment: "₹65000 + GST (Non-Refundable)",
      offer: "Refundable Offer: Achieve 90KW EPC projects in 18 months.",
    },
    {
      title: "Riyansh Advance Franchise",
      category: "Advance Franchise",
      tagline: "Expand & Scale Your Business!",
      description:
        "Take your solar business to the next level by building a strong sales network.",
      features: [
        "Wider market access – Sell solar products & solutions across multiple locations.",
        "Higher profit margins – Earn direct sales commissions and a share of downline sales.",
        "Complete business package – Receive marketing materials, banners, and sample products.",
        "Distributor rights – Appoint Independent Partners to expand your business.",
      ],
      investment: "₹245000 + GST (Non-Refundable)",
      offer: "Refundable Offer: Achieve 150KW EPC projects in 18 months.",
    },
    {
      title: "Riyansh Channel Partner",
      category: "Channel Partner",
      tagline: "Dominate the Solar Industry!",
      description:
        "The Channel Partner Franchise is for business leaders who want to operate at a city/district level.",
      features: [
        "Exclusive large-scale operations – Work at a city/district level with open market business.",
        "Five revenue streams – Earn from direct sales, distributor commissions, tenders, AMC, and franchise fees.",
        "Access to government tenders – NHPC-registered for large solar project participation.",
        "Full business setup – Receive product training, marketing materials, and an exclusive business website.",
      ],
      investment: "₹5,00,000 + GST (Non-Refundable)",
      offer: "Bonus Incentives: Achieve 350KW EPC projects in 18 months.",
    },
  ];

  // ===== FILTER LOGIC =====
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Map buttons to actual data categories
  const categoryMap = {
    All: "All",
    "Startup Franchise": "Start Up Franchise",
    "Expert Franchise": "Advance Franchise",
    "Channel Partner": "Channel Partner",
  };

  const filteredData =
    selectedCategory === "All"
      ? franchiseData
      : franchiseData.filter(
          (item) => item.category === categoryMap[selectedCategory]
        );

  return (
    <>
      <Breadcrumb
        title="Business Franchise"
        bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg"
      />

      <Section pt="120" pb="100">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">
              Start Your Solar Business with Riyansh Solar Power Plus
            </h2>
            <p className="text-muted">
              Join the Fastest-Growing Solar Franchise Network in India! Partner
              with us and start your journey in the renewable energy sector with
              high earnings and full business support.
            </p>
          </div>

          {/* ==== FILTER BUTTONS ==== */}
          <div className="text-center mb-5">
            {Object.keys(categoryMap).map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`btn mx-2 mb-2 ${
                  selectedCategory === cat
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* ==== FRANCHISE CARDS ==== */}
          {filteredData.map((item, index) => (
            <div
              key={index}
              className="product-card mb-5 p-4 rounded shadow-sm bg-light"
            >
              <h3 className="text-accent mb-2">{item.title}</h3>
              <h5 className="text-secondary mb-3">{item.tagline}</h5>
              <p className="text-dark mb-3">{item.description}</p>

              <ul className="text-dark ps-3">
                {item.features.map((feature, i) => (
                  <li key={i} className="mb-1">
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="bg-warning-subtle p-3 rounded mt-3">
                <p className="fw-bold mb-1">
                  Franchise Investment: {item.investment}
                </p>
                <p className="text-success mb-0">{item.offer}</p>
              </div>
            </div>
          ))}

          <div className="text-center mt-5">
            <h4 className="fw-bold text-accent mb-3">How to Get Started?</h4>
            <ol className="d-inline-block text-start">
              <li>Submit your documents & KYC registration</li>
              <li>Complete your franchise investment payment</li>
              <li>Start your solar business with full support</li>
            </ol>
          </div>
        </div>
      </Section>
      <FranchiseForm />
    </>
  );
}
